// Barnard College's majors (#2739). Read on 2026-10-01 from the official
// Barnard College Catalogue, 2026-2027 Edition, Academic Fields of Study:
// every field listed under MAJORS AND MINORS, each of which offers a major
// (checked on its catalogue page). All Barnard majors lead to the B.A. The
// interdisciplinary minors, the CCIS minors and areas of focus, and the
// first-year and language requirements are left out. Human Rights Studies and
// Jewish Studies are offered as combined majors. Names are the catalogue's,
// with "and" for its ampersands.
const majors = {
    "slug": "barnard-college",
    "read": "2026-10-01",
    "intro": "Every major field in Barnard's official 2026-2027 Catalogue, each leading to the B.A. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Majors",
            "source": {
                "label": "Barnard College Catalogue 2026-2027, Academic Fields of Study",
                "url": "https://catalog.barnard.edu/barnard-college/courses-instruction/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Ancient Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Architecture",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian and Middle Eastern Cultures",
                    "degree": "B.A."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economic and Social History",
                    "degree": "B.A."
                },
                {
                    "name": "Economics and Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Education Studies",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environment and Sustainability",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.A."
                },
                {
                    "name": "European Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Film Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Human Rights Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Italian",
                    "degree": "B.A."
                },
                {
                    "name": "Jewish Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics-Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics-Statistics",
                    "degree": "B.A."
                },
                {
                    "name": "Medieval and Renaissance Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience and Behavior",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Russian and Slavic Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish and Latin American Cultures",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Urban Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Women's, Gender and Sexuality Studies",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
